import { useDispatch, connect } from "react-redux";
import React, { useEffect } from "react";
import {
  getLicense,
  clearAllGlobalLicenseMessages, updateLicense,
} from "../store/actions";
import { DataGrid } from "@mui/x-data-grid";
import GlobalLicense from "./globalLicense";
import GlobalAddons from "./globalAddons";

import { Row, Col, FormGroup, Alert } from "reactstrap";

import spinner from "../assets/images/loadingGif.gif";
import EditLicenseAndAddOns from "./EditLicenseAndAddOns";

import accessToken from "../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";


const parameters = {
  price: "Price",
  numberOfAssets: "Number of Assets",
  scanFrequency: "Scan Frequency",
  securityPosture: "Security Posture",
  securityPostureReport: "Security Posture Report",
  supportResponse: "Support Response",
  costInsight: "Cost Insight",
  eventInsight: "Event Insight",
};

export function transposeArray(plans) {
  //console.log("In transposeArray ", plans);
  const keys = Object.keys(plans[0]);
  //console.log("array keys ", keys);

  let newArray = [];

  for (const key of keys) {
    // if(key==='id' || key==='name'){
    //   continue;
    // }
    if (key === "id") {
      continue;
    }
    //console.log("Key = ", key);
    let row = { id: parameters[key] };
    let col = 0;
    const cols = ["basic", "standard", "premium", "enterprise"];
    for (const plan of plans) {
      if (key === "name") {
        row = { ...row, [cols[col]]: plan[key] };
      } else if (key === "price") {
        row = { ...row, [cols[col]]: "$ " + plan[key] };
      } else {
        row = { ...row, [cols[col]]: plan[key] };
      }
      col++;
    }
    row = { ...row, [cols[col]]: "Contact us" };
    newArray.push(row);
  }

  return newArray;
}

const GlobalLicenseAndAddons = (props) => {
  //For userRole identification
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  console.log("Props :: ", props);
  const globalData = props?.license;

  useEffect(() => {
    // const fetchGlobalLicense = async () => {
    //   await props.getGlobalLicense();
    //   console.log("GET Global License");
    // };
    // fetchGlobalLicense();
    if (!globalData) {
      props.getGlobalLicense();
    }
  }, [globalData]);

  //For displaying message for getting License
  let getLicenseMsg = props.getLicenseMessage;
  let getLicenseErr = props.getLicenseError;
  useEffect(() => {
    console.log("getLicenseMsg = " + getLicenseMsg);
    if (getLicenseMsg || getLicenseErr) {
      console.log("Inside if, getLicenseMsg = " + getLicenseMsg);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getLicenseMsg, getLicenseErr, props]);

  // if (!props.license) {
  //   // Return null or a loading state if you don't want to render anything
  //   return null;
  // }

  return (
    <div style={{marginTop:"10px"}}>
      {props.isGettingLicense && (
        <div
          style={{
            display: "flex",
            direction: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <img src={spinner} width="32px" alt="Spinner" />
        </div>
      )}
      {props.getLicenseMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.getLicenseMessage}
        </Alert>
      )}
      {props.getLicenseError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while getting License information.
          {JSON.stringify(props.getLicenseError.message)}
        </Alert>
      )}

      <Row style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
        <Col lg={10}>
          {globalData && (
            <div>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                <h5 style={{ color: "blue" }}>Global License Management</h5>
              </div>
              <div>
                <GlobalLicense license={globalData} />
              </div>
            </div>
          )}
        </Col>
        {/* <Col lg={5}>
          {globalData && (
            <div>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                <h5 style={{ color: "blue" }}>Global Addons Management</h5>
              </div>
              <div>
                <GlobalAddons addons={globalData} />
              </div>
            </div>
          )}
        </Col> */}
      </Row>
      {globalData && userRole.includes("Admin") && (
        <div>
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              flexWrap: "wrap",
              marginTop: "30px",
            }}
          >
            <h5 style={{ color: "blue" }}>Edit License and AddOns</h5>
          </div>
          <div>
            <EditLicenseAndAddOns data={globalData} />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    isGettingLicense,
    getLicenseError,
    getLicenseMessage,
    isUpdatingLicense,
    updateLicenseError,
    updateLicenseMessage,
    license,
  } = state.globalLicense;
  return {
    isGettingLicense,
    getLicenseError,
    getLicenseMessage,
    isUpdatingLicense,
    updateLicenseError,
    updateLicenseMessage,
    license,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGlobalLicense: () => {
      dispatch(getLicense());
    },
    clearAllMessages: () =>{
      dispatch(clearAllGlobalLicenseMessages());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalLicenseAndAddons);